






























































import { Component, Vue } from 'vue-property-decorator'
import rowEditor from '../../components/TextRowEditor.vue'
import { ApiBooleanResult } from '@/services/data'
import settingService from '@/services/settingService'
import { VForm } from '@/services/VForm'
import validation from '@/common/element-val'

@Component({
  components: {
    rowEditor
  }
})
export default class UserSettings extends Vue {
  $refs: {
    notBotForm: VForm;
    vpnForm: VForm;
    logForm: VForm;
  }

  notBot = {
    Token: '',
    NameOfBot: ''
  }

  vpn = {
    Ip: '',
    Timeout: ''
  }

  duration: number = null

  rules = {
    required: validation.required(this.$t('val.required') as string)
  }

  async saveSysSettings (name: string, value: any, valueType = 'json') {
    const res = await settingService.addOrUpdateSysSettingAsync([
      {
        Name: name,
        Value: valueType === 'json' ? JSON.stringify(value) : value.toString(),
        ValueType: 'Json'
      }
    ])
    this.showMessage(res)
  }

  async submitApiDuration () {
    if (this.$refs.logForm.validate()) {
      await this.saveSysSettings('coinmarketcap-api-cache-duration', this.duration, 'text')
    }
  }

  async submitNotBot () {
    if (this.$refs.notBotForm.validate()) {
      await this.saveSysSettings('NotBot', this.notBot)
    }
  }

  async submitVpn () {
    if (this.$refs.vpnForm.validate()) {
      await this.saveSysSettings('VPN', this.vpn)
    }
  }

  async mounted () {
    const res = await settingService.readSysSettingByNamesAsync(['NotBot', 'VPN', 'coinmarketcap-api-cache-duration'])
    const notBotItem = res.Result.find(p => p.Name === 'NotBot')
    if (notBotItem) {
      this.notBot = JSON.parse(notBotItem.Value)
    }
    const vpn = res.Result.find(p => p.Name === 'VPN')
    if (vpn) {
      this.vpn = JSON.parse(vpn.Value)
    }

    const duration = res.Result.find(p => p.Name === 'coinmarketcap-api-cache-duration')
    if (duration) {
      const v = parseInt(duration.Value)
      this.duration = isNaN(v) ? null : v
    }
  }

  private showMessage (res: ApiBooleanResult) {
    if (res.Error) {
      this.$alert(this.$t('msg.' + (res.Error || 'unableToSave')) as string)
    } else {
      this.$success(this.$t('msg.dataSaved') as string)
    }
  }
}
